<template>
  <v-container>
    <v-row :class="theme + '-alt-background-1'" v-if="breakpoint > 3">
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-carousel
          cycle
          interval="6000"
          show-arrows
          height="860"
        >
          <v-carousel-item
            @mouseover="onCarouselMouseOver"
            @mouseleave="onCarouselMouseLeave"
          >
            <v-sheet>
              <v-img :src="waterImage">
                <div class="carousel-choose">
                  <v-btn text outlined to="why">
                    <h1>{{ get("header-1") }}</h1>
                  </v-btn>
                </div>
                <v-row>
                  <v-col cols="12">
                    <div class="carousel-title">{{ get("company")}}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="carousel">
                      <div class="carousel-text">
                        {{ get("header-2") }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-img>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item
            @mouseover="onCarouselMouseOver"
            @mouseleave="onCarouselMouseLeave"
          >
            <v-sheet>
              <v-img :src="ducksImage" class="image">
                <div class="carousel-choose">
                  <v-btn text outlined to="why">
                    <h1>{{ get("header-1") }}</h1>
                  </v-btn>
                </div>
                <v-row>
                  <v-col cols="12">
                    <div class="carousel-title">
                      {{ get("header-3")}} {{ get("company")}}
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="carousel">
                      <div class="carousel-text">
                        <p>
                          {{ get("p-1") }}
                        </p>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-img>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item
            @mouseover="onCarouselMouseOver"
            @mouseleave="onCarouselMouseLeave"
          >
            <v-sheet>
              <v-img :src="certsImage" class="image">
                <div class="carousel-choose">
                  <v-btn text outlined to="why">
                    <h1>{{ get("header-1") }}</h1>
                  </v-btn>
                </div>
                <v-row>
                  <v-col cols="12">
                    <div class="carousel-title">
                      {{ get("header-4")}}
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="carousel">
                      <div class="carousel-text">
                        {{ get("p-2") }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-img>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item
            @mouseover="onCarouselMouseOver"
            @mouseleave="onCarouselMouseLeave"
          >
            <v-sheet>
              <v-img :src="estimateImage" class="image">
                <div class="carousel-choose">
                  <v-btn text outlined to="why">
                    <h1>{{ get("header-1") }}</h1>
                  </v-btn>
                </div>
                <v-row>
                  <v-col cols="12">
                    <div class="carousel-title">{{ get("header-5") }}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="carousel">
                      <div class="carousel-text">
                        {{ get("p-3") }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-img>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate ref="estimateComponent"></estimate>
      </v-col>
    </v-row>
    <v-row v-if="breakpoint <= 3">
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12">
            <v-img :src="waterImage" class="image">
              <div class="carousel-title">
                <v-btn text outlined to="why">
                  <h4>{{ get("header-1") }}</h4>
                  <v-icon right>mdi-help</v-icon>
                </v-btn>
              </div>
            </v-img>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
    <v-row :class="theme + '-alt-background-2'" v-if="breakpoint <= 3">
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <v-img :src="ducksImage" class="image"> </v-img>
      </v-col>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-card>
          <v-card-title>{{ get("header-3")}} {{ get("company")}}</v-card-title>
          <v-card-text>
            {{ get("p-3.1") }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row :class="theme + '-alt-background-2'" v-if="breakpoint <= 3">
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-card>
          <v-card-title>
            {{ get("header-4")}}
          </v-card-title>
          <v-card-text>
            {{ get("p-2") }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <v-img :src="certsImage" class="image"> </v-img>
      </v-col>
    </v-row>
    <v-row :class="theme + '-alt-background-2'">
      <v-col
        cols="12"
        xl="3"
        lg="3"
        md="6"
        sm="12"
        v-for="topic in topics"
        v-bind:key="topic.title"
      >
        <v-card>
          <v-card-title>{{ topic.title }} </v-card-title>
          <v-card-text>
            <v-img
              :src="topic.image"
              :aspect-ratio="16 / 9"
              class="topic-image"
            ></v-img>
            <div>
              {{ topic.teaser }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :to="topic.to">
              <v-icon>{{ topic.icon }}</v-icon
              >{{ get("header-6") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row :class="theme + '-alt-background-2'" v-if="breakpoint <= 3">
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-card>
          <v-card-title>
            {{ get("header-7") }}
          </v-card-title>
          <v-card-text>
            {{ get(" p-5") }}
            <phonenumber phone="(303) 778-7663"></phonenumber>
            {{ get("p-6") }}
            <linkto :text="contact" to="/contact"></linkto> 
            {{ get("p-7") }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <v-img :src="estimateImage" class="image"> </v-img>
      </v-col>
    </v-row>
    <v-row :class="theme + '-alt-background-2'" v-if="breakpoint <= 3">
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <v-img :src="awardImage" class="image"> </v-img>
      </v-col>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-card>
          <v-card-title>
            {{ get("header-9")}}
          </v-card-title>
          <v-card-text>
            {{ get("p-8") }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import breakpointMixin from "../mixins/breakpointMixin"
import estimate from "../components/controls/estimate-ctrl";
import linkto from "@/components/controls/link-to";
import localizationService from "@/_services/localization-service";
import phonenumber from "@/components/controls/phone-number";
import router from "@/router"
import store from "@/store"
import TopicService from "@/_services/topic-service";
import localizationMixin from "@/mixins/localization-mixin";

export default {
  name: "Home",

  components: {
    estimate,
    linkto,
    phonenumber,
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {
    this.pageName = "home";
    this.topics = TopicService.getTopics();
    this.textStyle.color = store.state.dark ? "gold" : "darkblue";
},

  data: () => ({
    cycle: true,
    contact: "Contact",
    estimateKey: 0,
    textStyle: {
      color: "darkblue",
    },
    topics: [],
    awardImage: require("@/assets/award-1.jpeg"),
    certsImage: require("@/assets/duck-2.jpeg"),
    ducksImage: require("@/assets/ducks-1.jpeg"),
    estimateImage: require("@/assets/estimate-1.jpg"),
    familyImage: require("@/assets/family-1.jpeg"),
    waterImage: require("@/assets/water-1.jpeg"),
}),

  mixins: [breakpointMixin, localizationMixin],

  methods: {

    getLocalization() {
      this.estimateKey++;
      this.contact = localizationService.get("header-8");
    },

    onCarouselMouseOver() {
      this.cycle = false
    },

    onCarouselMouseLeave() {
      this.cycle = true
    },

    removeElement(name) {
      const element = document.getElementById(name);
      if (element) {
        element.parentNode.removeChild(element);
      }
    },
  },

  watch: {
    "$store.state.localization"() {
      this.getLocalization();
      this.topics = TopicService.getTopics();
      
    },

  },

  router,
  store,
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Nanum Pen Script');
.button {
  margin-right: 20px;
  margin-left: 20px;
}
.v-application .title {
  font-family: 'Nanum Pen Script', sans-serif !important;
  font-size: 2.0rem !important;
}
.carousel {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 350px;
}
.carousel-choose {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 25px;
}
.carousel-title {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 70px;
  margin-right: 50px;
  margin-top: 20px;
  font-size: 3em;
  color: aqua;
  background-color: rgba(0, 0, 0, 0.5);
}
.carousel-text {
  align-items: center;
  display: flex;
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20;
  font-size: 2em;
  color: aqua;
  background-color: rgba(0, 0, 0, 0.5);
}
.map {
  margin: 20px;
  width: 100%;
}
.projects {
  margin-left: 20px;
}
.topic-image {
  margin-bottom: 20px;
}

</style>
